// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";

/**
 * Poskytovatel odeslání emailu pro sdílecí okno
 */
window.MyMapsEmailProvider = class {
		constructor() {
			this._emailPattern =  /^[\w]+([\w._#\/ +$%=-][\w]+)*@[\w]+([\w.-]+[\w]+)*\.[\w]{2,5}$/;

			this.SUCCESS = _("sendByMail.success");
			this.NO_SEND = _("sendByMail.noSend");
			this.NO_SUCCESS = _("sendByMail.noSuccess");
			this.BAD_SENDER = _("sendByMail.badSender");
			this.BAD_RECIPIENT = _("sendByMail.badRecipient");
			this.BAD_IP = _("sendByMail.errorIP");
		}

		/**data.to = to;
		data.from = from;
		data.message = this._dom.mailMessage.value;
		data.link
		 * Postará se o odeslání dat, vrací objekt
		 * @param {Object} data Data k odeslání
		 * @param {String} data.to Příjemce
		 * @param {String} data.from Odesílatel
		 * @param {String} data.message Zpráva
		 * @param {String} data.link URL, která se posílá v emailu
		 * @return {Object} {error[String], success[String]}
		 */
		send (data) {
			let retStatus = {error: null, success: null};

			data.type = "image";
			data.width = 600;
			data.height = 400;

			return Mapy.Util.request("/mapyMessageProcess", {
				method: "post",
				json: data,
				headers: {
					"accept": "application/json"
				},
			}).promise.then(info => {
				if (info.status.toString().charAt(0) != "2") {
					retStatus.error = this.NO_SUCCESS;
					return retStatus;
				}

				let intStatus = info.status;

				if (intStatus.toString().charAt(0) != "2") {
					retStatus.error = this._setErrorMessage(info, intStatus);
					return retStatus;
				}

				retStatus.success = this.SUCCESS;
				return retStatus;
			}).catch(error => {
				retStatus.error = this.NO_SUCCESS;
				return retStatus;
			});
		}


		/**
		 * Zkontroluje e-mailové adresy odesílatele a příjemnce
		 * @param {String} from E-mailová adresa odesílatele
		 * @param {String} to E-mailová adresa příjemce
		 * @return {Object} {from[Boolean], to[Boolean]}
		 */
		checkAddress (from, to) {
			return ({
				from: this._emailPattern.test(from),
				to: this._emailPattern.test(to)
			});
		}

		/**
		 * Zkobntroluje data získaná ze serveru a vrátí případnou chybu
		 * @param {Object} data data odpovědi při odeslání
		 * @param {Number} status HTML status
		 * @return {String}
		 */
		_setErrorMessage (data, status) {
			if(status != 400) {
				return this.NO_SUCCESS;
			}

			if(!data.key) {
				return this.NO_SUCCESS;
			}

			let text = "";
			switch(data.key) {
				case "ip":
					text += this.BAD_IP;
					break;
				case "from":
					text += this.NO_SUCCESS + "\n" + this.BAD_SENDER;
					break;
				case "to":
					text += this.NO_SUCCESS + "\n" + this.BAD_RECIPIENT;
					break;
				default:
					text += this.NO_SUCCESS;
			}

			return text;
		}


}
